<template>
  <div class="tw-w-full tw-px-2 md:tw-px-8">
    <v-form class="tw-py-4" v-model="valid" @submit.prevent="onCalculate" ref="form">
      <div class="tw-flex tw-flex-col">
        <div class="tw-flex tw-flex-col md:tw-flex-row">
          <div class="tw-w-full md:tw-w-1/3 tw-px-2 lg:tw-px-6">
            <label for="surname" class="tw-text-sm c-blue-text">Surname</label>
            <v-text-field type="text" name="surname" id="surname" v-model="form.surname" :rules="[required('Surname')]"
              required></v-text-field>
          </div>
          <div class="tw-w-full md:tw-w-1/3 tw-px-2 lg:tw-px-6">
            <label for="othernames" class="tw-text-sm c-blue-text">Other Names</label>
            <v-text-field type="text" name="othernames" id="othernames" v-model="form.othernames"
              :rules="[required('Other Name(s)')]" required></v-text-field>
          </div>
          <div class="tw-w-full md:tw-w-1/3 tw-px-2 lg:tw-px-6">
            <label for="email" class="tw-text-sm c-blue-text">Email Address</label>
            <v-text-field type="email" name="email" id="email" v-model="form.email"
              :rules="[required('Email Address'), emailFormat()]" required></v-text-field>
          </div>
        </div>
        <div class="tw-flex tw-flex-col md:tw-flex-row tw-mt-4">
          <div class="tw-w-full md:tw-w-1/3 tw-px-2 lg:tw-px-6">
            <label for="dateOfBirth" class="tw-text-sm c-blue-text">Date of Birth</label>
            <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y
              max-width="290px" min-width="290px">
              <template #activator="{ on, attrs }">
                <v-text-field v-model="form.dateOfBirth" persistent-hint readonly v-bind="attrs" v-on="on"
                  :rules="[required('Date of Birth')]"></v-text-field>
              </template>
              <v-date-picker id="dateOfBirth" :active-picker.sync="activePicker" v-model="form.dateOfBirth" no-title
                @input="menu = false" :max="givenYearsAgo(18)" :min="givenYearsAgo(65)" color="primary"></v-date-picker>
            </v-menu>
          </div>
          <div class="tw-w-full md:tw-w-1/3 tw-px-2 lg:tw-px-6">
            <label for="term" class="tw-text-sm c-blue-text">Term in Years</label>
            <v-select id="term" v-model="form.term" :items="getTerms" dense
              :rules="[required('Term in Years')]"></v-select>
          </div>
          <div class="tw-w-full md:tw-w-1/3 tw-px-2 lg:tw-px-6">
            <label for="amount" class="tw-text-sm c-blue-text">{{ amountTitle }}</label>
            <vuetify-money id="amount" ref="amount" v-model="form.amount" name="amount" :rules="[
              required('amount is required'),
              switch1 ? minAmount(amountTitle, 100000) : null,
            ]" :options="options"></vuetify-money>
            <small v-if="switch1" class="c-yellow-text tw-italic">
              <v-icon size="14" color="secondary">mdi-information-outline</v-icon> Minimum sum
              assured is KES. 100,000</small>
          </div>
        </div>
        <div class="tw-flex tw-flex-col md:tw-flex-row tw-mt-4">
          <div class="tw-w-full md:tw-w-1/3 tw-px-2 lg:tw-px-6">
            <label for="premiumSwitch" class="tw-text-sm c-blue-text" >Premium / Sum Assured (Switch)
              <v-switch class="pl-10 pt-4" id="premiumSwitch" v-model="switch1"></v-switch></label>
          </div>
          <div class="tw-w-full md:tw-w-1/3 tw-px-2 lg:tw-px-6">
            <label for="freqOfPayment" class="tw-text-sm c-blue-text">Payment Frequency</label>
            <div></div>
            <v-select id="freqOfPayment" v-model="form.freqOfPayment" :items="payFreq" item-text="label"
              item-value="value" dense :rules="[required('Payment Frequency')]"></v-select>
          </div>
          <div class="tw-px-2 md:tw-px-6 tw-w-full md:tw-w-1/3 lg:tw-px-6">
            <label for="benefits" class="tw-text-sm c-blue-text">Additional Benefits</label>

            <!-- Responsive flex-column layout for small screens, grid for larger screens -->
            <div class="tw-flex tw-flex-col md:tw-grid md:tw-grid-cols-1 tw-gap-y-2 md:tw-gap-y-6 tw-mt-2">
              <div v-for="(benefit, i) in benefits" :key="i" class="tw-my-2 md:tw-my-0">
                <v-checkbox
                  v-if="!((form.freqOfPayment === 'Sp' || form.freqOfPayment === 'A') && benefit.coverName === 'Retrenchment')"
                  v-model="form.benefits" id="benefits" :value="benefit.coverProdCode"
                  :label="benefit.coverName"></v-checkbox>
              </div>
            </div>
          </div>

        </div>
        <div class="tw-w-full tw-px-2 lg:tw-px-6 tw-flex tw-justify-center tw-mt-3 md:tw-mt-6">
          <v-btn color="secondary" :loading="loading" :disabled="!valid" type="submit">Calculate</v-btn>
        </div>
      </div>
    </v-form>

    <AuthModal
      :show="showAuthModal"
      :loading="loading2"
      @submit="handleAuthModalSubmit"
    />
    <OtpModal
      :show="showOtpModal"
      :loading="loading2"
      :email="authEmail"
      @submit="handleOtpSubmit"
      @resend-otp="handleResendOTP"
    />
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import validations from '@/utils/validations';
import { age, givenYearsAgo } from '@/utils/time';
import AuthModal from './AuthModal.vue';
import OtpModal from './OtpModal.vue';
import authenticationMixin from '@/mixins/authenticationMixin';

export default {
  name: 'ClientQuotation',
  mixins: [authenticationMixin],
  components: {
    AuthModal,
    OtpModal,
  },
  props: ['productData', 'benefits', 'terms'],
  data() {
    return {
      valid: false,
      showAuthModal: false,
      showOtpModal: false,
      dateFormatted: '',
      menu: false,
      time: null,
      menu2: false,
      loading: false,
      loading2: false,
      authEmail: '',
      pendingQuoteData: null,
      form: {
        name: '',
        surname: '',
        othernames: '',
        email: '',
        dateOfBirth: '',
        term: null,
        freqOfPayment: '',
        benefits: [],
        amount: null,
      },
      ...validations,
      options: {
        locale: 'en',
        prefix: 'KES',
        suffix: '',
        precision: 0,
      },
      amountTitle: 'Sum Assured',
      switch1: true,
      amount: null,
      activePicker: null,
      payFreq: [
        { label: 'Monthly', value: 'M' },
        { label: 'Quarterly', value: 'Q' },
        { label: 'Semi Annually', value: 'S' },
        { label: 'Annually', value: 'A' },
        { label: 'Single Premium', value: 'Sp' },
      ],
    };
  },
  watch: {
    async switch1(val) {
      this.amountTitle = val ? 'Sum Assured' : 'Premium';
      await this.$nextTick();
      this.$refs.form.validate();
    },
    'form.dateOfBirth': async function (val) {
      await this.$nextTick();
      if (this.age(val) >= 50) this.form.term = null;
    },
    'form.freqOfPayment': function (val) {
      if (val === 'A' || val === 'Sp') this.form.benefits = [];
    },
    menu() {
      setTimeout(() => {
        this.activePicker = 'YEAR';
      });
    },
  },
  computed: {
    sumAssured: {
      get() {
        return this.switch1 ? this.form.amount : 0;
      },
    },
    ...mapState({
      agentCode: (state) => (state.auth.userInfo ? state.auth.userInfo.agentCode : 0),
      prospectCode: (state) => (state.quote.clientResp ? state.quote.clientResp.prospectCode : null),
    }),
    premium: {
      get() {
        return this.switch1 ? 0 : this.form.amount;
      },
    },
    getTerms() {
      const newTerms = this.form.dateOfBirth
        ? this.terms.filter((i) => i <= 70 - this.age(this.form.dateOfBirth))
        : this.terms;
      return newTerms?.map(String);
    },
  },
  created() {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'clientquotation_page_visited_by_agent', {
        event_category: 'client quotation component created',
        event_label: 'client quotation component created',
      });
    }
  },
  methods: {
    prepareFormData() {
      this.form.name = `${this.form.surname} ${this.form.othernames}`;
      return {
        quoteCode: 0,
        quoteAgentCode: this.agentCode,
        clientCode: 0,
        ...this.form,
        ...this.productData,
        sumAssured: this.switch1 ? parseInt(this.form.amount, 10) : 0,
        premium: this.switch1 ? 0 : parseInt(this.form.amount, 10),
      };
    },

    onCalculate() {
      this.requireAuthentication(() => {
        this.loading = true;
        this.form.name = `${this.form.surname} ${this.form.othernames}`;
        this.$store.commit('userPersonalData/updatePersonalData', this.form);

        const formData = this.prepareFormData();

        return axios.post('/lmsagent/quotations/saveQuote', formData)
          .then((res) => {
            const quotationResp = res.data.data || res.data;
            this.$store.commit('quote/clientInfo', quotationResp);
            // Cache result for OTP flow; authenticated agents go straight to summary
            this.pendingQuoteData = quotationResp;
            if (this.$store.getters['auth/isAuthenticated']) {
              this.$emit('to-quote-summary', quotationResp);
            }
          })
          .finally(() => { this.loading = false; });
      });
    },

    // ──────────────────────────────────────────────────────────────────────────
    // Prospect / public OTP flow
    // These methods override the mixin's agent-login variants for THIS component
    // only. Other consumers of authenticationMixin are unaffected.
    // ──────────────────────────────────────────────────────────────────────────

    /**
     * Called when the AuthModal is submitted by a public prospect.
     * Validates phone (10 digits) + any valid email — NO agent-code check.
     * Saves the quote via the stored pendingCallback, then generates and sends
     * an OTP to the prospect, and opens the OTP modal.
     */
    async handleAuthModalSubmit(authForm) {
      this.loading2 = true;

      const phone = authForm.prospectTelephone;
      const email = authForm.prospectEmail;

      // Phone: exactly 10 digits
      const phoneRegex = /^\d{10}$/;
      if (!phone || !phoneRegex.test(phone)) {
        this.$toast.error('Please enter a valid 10-digit phone number');
        this.loading2 = false;
        return;
      }

      // Email: any properly-formed address
      if (!email || !/.+@.+\..+/.test(email)) {
        this.$toast.error('Please enter a valid email address');
        this.loading2 = false;
        return;
      }

      this.authEmail = email;
      this.showAuthModal = false;

      // Run the pending callback → saves the quote and stores quoteCode in Vuex
      if (this.pendingCallback) {
        try {
          await this.pendingCallback();
        } catch {
          this.$toast.error('Failed to save quote. Please try again.');
          this.loading2 = false;
          return;
        }
      }

      // Retrieve quoteCode that was just persisted by the callback
      const { quoteCode } = this.$store.state.quote;
      if (!quoteCode) {
        this.$toast.error('Could not retrieve quote code. Please try again.');
        this.loading2 = false;
        return;
      }

      // Generate & send OTP to the prospect
      try {
        const res = await axios.post(
          `/lmsagent/quotations/generateOtpRequest?QuoteCode=${quoteCode}`,
        );
        const status = res.data?.responseStatus?.description;
        if (status === 'succeeded' || res.data?.success) {
          this.$toast.success('OTP sent successfully');
          this.showOtpModal = true;
        } else {
          this.$toast.error(status || 'Failed to send OTP. Please try again.');
        }
      } catch {
        this.$toast.error('Failed to generate OTP. Please try again.');
      }

      this.loading2 = false;
    },

    /** Verifies the OTP; on success navigates to the quote summary. */
    async handleOtpSubmit(otp) {
      this.loading2 = true;
      const { quoteCode } = this.$store.state.quote;
      try {
        const res = await axios.post(
          `/lmsagent/quotations/verifyOtpRequest?QuoteCode=${quoteCode}&otp=${otp}`,
        );
        if (res.data.data === true) {
          this.showOtpModal = false;
          if (this.pendingQuoteData) {
            this.$emit('to-quote-summary', this.pendingQuoteData);
          }
        } else {
          this.$toast.error(
            res.data?.responseStatus?.description || 'Invalid OTP. Please try again.',
          );
        }
      } catch {
        this.$toast.error('OTP verification failed. Please try again.');
      }
      this.loading2 = false;
    },

    /** Resends the OTP using the already-saved quoteCode. */
    async handleResendOTP() {
      const { quoteCode } = this.$store.state.quote;
      try {
        await axios.post(`/lmsagent/quotations/generateOtpRequest?QuoteCode=${quoteCode}`);
        this.$toast.success('OTP resent successfully');
      } catch {
        this.$toast.error('Failed to resend OTP. Please try again.');
      }
    },
    givenYearsAgo,
    age,
  },
};
</script>
